let exported = require("css-element-queries")

angular.module('eatself')
.directive('ensureMarginBottomEquals', function($timeout,$state) {
  return {
    scope: {},
    link: function($scope, $element, $attrs) {
      function init() {
        let otherElement = $($attrs.ensureMarginBottomEquals);
        function cb() {
          if ($state.is($attrs.ensureMarginBottomDisableForState)) {
            $element.css('margin-bottom',-(parseInt($element.css('margin-top'))+otherElement.outerHeight()))
          } else {
            $element.css('margin-bottom',-otherElement.outerHeight())
          }
        }
        new exported.ResizeSensor(otherElement, cb);
        cb()
      }
      $timeout(init)
    }
  };
})
